import state from './diagnostic.state'
import mutations from './diagnostic.mutations'
import actions from './diagnostic.actions'

export default {
  state,
  mutations,
  actions
}
